import {asIntWithRadix} from './asIntWithRadix';

export const asInt = asIntWithRadix(10);
